const TicketsSimple = ({ isActive = false, className = "" }) => {
  const fill = isActive ? "white" : "#9a9a9a";
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.5 0.75V3.75C14.8672 3.75 14.375 4.26562 14.375 4.875C14.375 5.50781 14.8672 6 15.5 6V9H2.75V6C3.35938 6 3.875 5.50781 3.875 4.875C3.875 4.26562 3.35938 3.75 2.75 3.75V0.75H15.5ZM1.625 2.8125V10.125H12.6875H13.25V11.25H12.6875H1.0625H0.5V10.6875V2.8125V2.25H1.625V2.8125Z"
        fill={fill}
      />
    </svg>
  );
};

export default TicketsSimple;
